import httpService from "..";

export const searchAddonsApi = async (groupId: string, search: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/addon/search?search=${search}&groupId=${groupId}`,
    "get"
  );
};

export const getAddonsApi = async () => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/addon`,
    "get",
  );
};

export const getAddonApi = async (id: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/addon/${id}`,
    "get",
  );
};

export const getCompanyAddonsApi = async (groupId: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/addon/group/${groupId}`,
    "get",
  );
};

export const addAddonApi = async (data: {}) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/addon`,
    "post",
    data
  );
};

export const editAddonApi = async (
  id: string,
  data: any
) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/addon/${id}
    `,
    "patch",
    data
  );
};

